import { createSlice } from '@reduxjs/toolkit';

export const OUTBOUND_SMS_FEATURE = 'outboundSMS';
export const ROADSIDE_ASSISTANCE_FEATURE = 'roadside_assistance';

const initialState = {
  selectedFeature: null,
  tempMessage: null,
  // Resolved smart-phrase values inside tempMessage that must not be
  // translated. Travels with the message so whichever chat prefills it can tag
  // the eventual send.
  tempMessageDoNotTranslate: [],
};

export const outboundSmsSlice = createSlice({
  name: 'outboundSms',
  initialState: initialState,
  reducers: {
    setSelectedFeature: (state, action) => {
      return {
        ...state,
        selectedFeature: action.payload,
      };
    },
    // Payload is `{ message, doNotTranslate }`, or null once consumed.
    setTempMessage: (state, action) => {
      const { message = null, doNotTranslate = [] } = action.payload ?? {};

      return {
        ...state,
        tempMessage: message,
        tempMessageDoNotTranslate: doNotTranslate,
      };
    },
  },
});

export const { setSelectedFeature, setTempMessage } = outboundSmsSlice.actions;

export default outboundSmsSlice.reducer;
